<mat-dialog-content>
  <div class="dialog-processing-header">
    <mat-spinner [diameter]="diameter" aria-hidden="true"></mat-spinner>
    <div class="text-headline-3">
      <div class="spinner-message" [innerHTML]="message"></div>
    </div>
    <p *ngIf="subMessage" class="text-center mb-0" [innerHTML]="subMessage"></p>
  </div>
</mat-dialog-content>
